import axios from "axios";
import { removeCookiesOnLogout } from "src/utils";
import { baseURL } from "src/utils/apiEndpoints";
import { loadData } from "src/utils/localStorage";

axios.interceptors.request.use(
  (config) => {
    const tempConfig = config;
    tempConfig.baseURL = baseURL;
    tempConfig.withCredentials = true;
    tempConfig.timeout = 15000;
    tempConfig.headers = tempConfig.headers || {};

    const token = loadData<{ authToken:string }>('authorization')
    if (token) {
      tempConfig.headers['x-access-token'] = token.authToken;
    }
    return tempConfig;
  },

  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      removeCookiesOnLogout();
      window.location.href = "/";
    } else if (error?.response?.status === 500) {
      if (error.config?.url === "auth/logout") {
        removeCookiesOnLogout();
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
